import { AccessControlManager } from "./accesscontrol-manager.js";

/**
 * Access Control Dialog
 * 
 * Modal dialog wrapper around AccessControlManager
 * Used for editing access rights for servers and datasets
 */
export async function accessControlDialogCreate({scope, resource, selectedServerId}) {
  d3.select(".admin-page").classed("blurry", true);
  
  const container = d3.select(".access-control-dialog")
    .style("visibility", "visible")
    .html("");

  container.append("div").attr("class", "blur");
  const box = container.append("div").attr("class", "box fancy-art-deco-card");

  box.append("div").class("corner top left")
  box.append("div").class("corner top right")
  box.append("div").class("corner bottom left")
  box.append("div").class("corner bottom right")

  box.append("div")
    .attr("class", "header")
    .text(`${resource} ${scope} access`);
    
  box.append("div")
    .attr("class", "closecross")
    .text("✕")
    .on("click", () => accessControlDialogCancel());

  const content = box.append("div").attr("class", "content");
  const msg = box.append('div').attr('class', 'form-msg');

  // Message utilities
  const message = {
    bad: (text) => msg.attr('class', 'form-msg is-error').text(text),
    info: (text) => msg.attr('class', 'form-msg').text(text),
    progress: (text) => msg.attr('class', 'form-msg').text(text),
    good: (text) => msg.attr('class', 'form-msg is-ok').text(text)
  };

  // Create access control manager
  const manager = new AccessControlManager({
    container: content,
    message,
    scope,
    resource,
    selectedServerId,
    showAddButton: true,
    showExplanations: true
  });

  await manager.render();
}

export function accessControlDialogCancel() {
  d3.select(".admin-page").classed("blurry", false);
  d3.select(".access-control-dialog")
    .style("visibility", "hidden")
    .html("");
}
